import { presetToISORange } from 'shared/utils/timePresets';

export function timeAgo(dateStr) {
  if (!dateStr) return '—';
  const secs = Math.floor((Date.now() - new Date(dateStr)) / 1000);
  if (secs < 60) return 'just now';
  const mins = Math.floor(secs / 60); if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60); if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24); if (days < 7) return `${days}d ago`;
  const weeks = Math.floor(days / 7); if (weeks < 5) return `${weeks}w ago`;
  const months = Math.floor(days / 30); if (months < 12) return `${months}mo ago`;
  return `${Math.floor(days / 365)}y ago`;
}

export function errorText(e) {
  return e?.response?.data?.message || e?.response?.data?.error || e?.message || 'Something went wrong';
}

/** The dashboard's stored window → the time filter's preset id. */
export function presetFromWindow(w) {
  const p = w && w.preset;
  return { '1h': '24h', '24h': '24h', '7d': '7d', '14d': '30d', '30d': '30d', '90d': '3m' }[p] || '7d';
}

/** The time filter's preset → the window a card runs over. */
export function windowFromPreset(preset, custom) {
  if (preset === 'custom' && custom && (custom.from || custom.to)) {
    return {
      from: custom.from || new Date(Date.now() - 7 * 86400e3).toISOString(),
      to: custom.to || new Date().toISOString(),
    };
  }
  return presetToISORange(preset) || presetToISORange('7d');
}

/** The time filter's preset → what a dashboard stores (its own vocabulary). */
export function storedWindow(preset) {
  return { preset: { '24h': '24h', '7d': '7d', '30d': '30d', '3m': '90d' }[preset] || '7d' };
}
